import { createFileRoute } from '@tanstack/react-router'
import { UsersPage } from '@/features/admin/UsersPage'
import { requireNav } from '@/nav/guard'

export const Route = createFileRoute('/_app/users')({
  beforeLoad: requireNav('users'),
  component: UsersPage,
})
